import React from "react";
import { SectionBadge } from "./Comparison";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Sarah M.",
    city: "Restaurant group, Birmingham",
    amount: "£350k",
    text: "Needed working capital to open a second site. High-street bank said 8 weeks — SwiftCash had signed terms in 48 hours. Kitchen was open six weeks later.",
  },
  {
    name: "David R.",
    city: "E-commerce founder, Manchester",
    amount: "£1.2M",
    text: "Q4 stock finance sorted in a week. No PGs across every director, transparent fees, and drawn-down before the shipping window closed.",
  },
  {
    name: "Priya K.",
    city: "Dental practice owner, London",
    amount: "£850k",
    text: "Commercial mortgage on the freehold. Our bank ran us round for months. SwiftCash brought us three lenders in 5 days — completed at a rate we'd have never got direct.",
  },
  {
    name: "Tom H.",
    city: "Logistics MD, Leeds",
    amount: "£2.4M",
    text: "12 new vans on asset finance. The whole panel bid on it. Rates came down by 1.4% just by having them compete. Genuine broker value.",
  },
  {
    name: "Emma W.",
    city: "Care-home group, Sheffield",
    amount: "£18M",
    text: "Acquisition finance for our fifth site. Complex structure, existing debt to refinance. They quarterbacked the whole deal — legal, valuation, drawdown. Clean.",
  },
  {
    name: "James L.",
    city: "Property developer, Bristol",
    amount: "£6.8M",
    text: "Bridging finance for an auction purchase. Terms in 24 hours, funds in 8 days. Wouldn't have won the lot without them moving that fast.",
  },
];

export default function Testimonials() {
  return (
    <section className="relative bg-paper-warm py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <SectionBadge>Real UK businesses</SectionBadge>
          <h2 className="font-display font-extrabold text-[40px] md:text-[56px] leading-[1.02] tracking-[-0.035em] text-navy mt-5">
            Trusted by thousands<br />
            of UK businesses.
          </h2>
          <div className="mt-6 inline-flex items-center gap-2 text-[13px] font-semibold text-navy/65">
            <div className="flex">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-amber text-amber" />)}
            </div>
            <span className="font-extrabold text-navy">4.8 / 5</span>
            <span>· Rated by UK business owners on Trustpilot</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i + 1}`}
              className="rounded-[20px] bg-white border border-line p-7 hover:shadow-card hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-5">
                {[...Array(5)].map((_, j) => <Star key={j} className="h-3.5 w-3.5 fill-amber text-amber" />)}
              </div>
              <p className="text-[15px] leading-[1.65] text-navy/80 font-medium mb-8 flex-1">
                &ldquo;{r.text}&rdquo;
              </p>
              <div className="flex items-center justify-between pt-5 border-t border-line">
                <div>
                  <div className="font-display font-extrabold text-[14.5px] text-navy tracking-[-0.015em]">{r.name}</div>
                  <div className="text-[12px] text-navy/55 font-semibold mt-0.5">{r.city}</div>
                </div>
                <div className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-emerald-soft text-emerald-3 font-display font-extrabold text-[13px] tracking-[-0.01em]">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald" />
                  {r.amount} funded
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
